// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon[data-v-394060de]{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden;fill:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
